<!--
 * @Author: your name
 * @Date: 2021-04-12 16:12:42
 * @LastEditTime: 2021-08-30 15:06:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\views\home\layout\EcSideBar.vue
-->
<template>
  <div class='ec-sidebar'>
    <logo v-if="showLogo" :collapse="isCollapse"/>
    <ec-menu></ec-menu>
    <div class="ec-menu__fold" @click="toggleSideBar">
      <i :class="isCollapse ?  'el-icon-s-unfold': 'el-icon-s-fold'"></i>
    </div>
  </div>
</template>
<script>
import EcMenu from '../components/EcMenu'
import Logo from './Logo'
import { mapState } from "vuex";
export default {
  components: {
    EcMenu,
    Logo
  },
  computed: {
    ...mapState(["isCollapse"]),
    showLogo() {return true;},
    isCollapse() {
      return this.$store.state.isCollapse
    }
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('setIsCollapse')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/theme/variables.scss";
.ec {
  &-theme {
    height: 50px;
    &__title {
      color: $primaryTxtColor;
    }
  }
  &-theme__img {
    width: 30px;
    height: 30px;
    background: url('~@/assets/img/logo.png') no-repeat;
    background-size: 100% auto;
  }
  &-menu__fold {
    height: 24px;
    background: #262C33; // 菜单按钮
    padding-left: 20px;
    color: rgba(255, 255, 255, 0.6);
    &:hover {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/layout/EcSideBar.vue